import React, { useState, useEffect } from "react";
import Logo from "../assets/idea-logo.png";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import Alerts from "../helper/Alert";

const Charity = () => {
  const navigate = useNavigate();


  const [documentData, setDocumentData] = useState([]);
  // New state for radio buttons and Aadhaar input
  // const [hasAppliedBefore, setHasAppliedBefore] = useState(null);
  // console.log("HAS", hasAppliedBefore);


  const handleNew = () => {
    navigate("/development/apply");
  };

  const API_URL = process.env.React_App_Api;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get(`${API_URL}/website/listall`);
        setDocumentData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [API_URL]);

  useEffect(() => {
    if (documentData.length > 0 && documentData[0].status) {
      navigate("/closed", { state: { comments: documentData[0].comments } });
    }
  }, [documentData, navigate]);

  const [alert, setAlert] = React.useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleCloseAlert = () => {
    setAlert({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <div
      style={{
        // backgroundImage: `url("/background.jpg")`, // Replace with your background image path
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <Alerts
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={handleCloseAlert}
      />

      <div
        style={{
          textAlign: "center",
          marginTop: "50px",
          marginBottom: "50px",
        }}
      >
        <img src={Logo} alt="logo" width={"60"} height={"60"} />
        <p style={{ fontWeight: "bold", fontSize: "20px" }}>IDEA-USA</p>
        <>
          <h1 style={{ fontSize: "20px", marginTop: "50px" }}>
            Submit your development project
          </h1>
          <button
            onClick={handleNew}
            style={{
              margin: "15px",
              borderRadius: "3px",
              backgroundColor: "#1789FB",
              border: "none",
              fontWeight: "bold",
              padding: "5px",
              color: "white",
              fontSize: "14px",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#1FA150")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#1789FB")
            }
          >
            Apply Now
          </button>
        </>
      </div>
    </div>
  );
};

export default Charity;
